<ng-container *ngIf="errors">
  <div class="alert alert-danger" *ngFor="let error of errors">
    {{error}}
  </div>
</ng-container>
